import { useEffect } from 'react'

export const useWindowFocusCallback = (callback: () => void): void => {
  useEffect(() => {
    const handleFocus = callback

    window.addEventListener('focus', handleFocus)

    return () => {
      window.removeEventListener('focus', handleFocus)
    }
  }, [callback])
}
